import { useState } from "react";
import { Link } from "react-router-dom";

import TopBarLogo from "./TopBarLogo";
import Burger from "../Burger/Burger";
import BurgerMenu from "../BurgerMenu/BurgerMenu";

import classes from "./TopBar.module.css";

const TopBar = () => {
  const [open, setOpen] = useState(false);

  const clickHandler = () => {
    setOpen(!open);
  };

  return (
    <header className={classes.header}>
      <Link to="/">
        <TopBarLogo />
      </Link>
      <nav>
        <Burger onClick={clickHandler} open={open} />
        {open && (
          <BurgerMenu>
            <ul>
            </ul>
          </BurgerMenu>
        )}
        <ul className={classes.menu}>
        </ul>
      </nav>
    </header>
  );
};

export default TopBar;
